import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Layout from './components/Layout/layout.vue';
import LoginView from './views/login/Common';
import PassWord from './views/login/PassWord';
import TurnInex from './views/turnSystem/index.vue';
import { message } from 'ant-design-vue';
import Cookies from 'js-cookie';
import db from './common/localstorage';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);

let routes = [
  { path: '/', redirect: '/index' },
  {
    path: '/index',
    name: 'index',
    component: () => import('./views/defaultHome/index.vue')
  },
  {
    path: '/workbench',
    name: '工作台管理',
    component: () => import('./views/workbench/index.vue')
  },
  {
    path: '/molecular',
    name: 'layout',
    component: () => import('@/components/molecular/layout.vue'),
    children: [
      {
        path: '/molecular',
        name: 'Database',
        component: () => import('./views/molecularData/index.vue')
      },
      {
        path: '/genomics',
        name: '突变可视化页面',
        component: () => import('./views/molecularData/genomicsIndex.vue')
      },
    ]
  },
  {
    path: '/analysis',
    name: 'layout',
    component: () => import('@/components/analysisPipelines/layout.vue'),
    children: [
      {
        path: '/analysis',
        name: 'Analysis',
        component: () => import('./views/analysisPipelines/index.vue')
      },
      {
        path: '/analysis/details',
        name: 'Analysis',
        component: () => import('./views/analysisPipelines/details.vue')
      },
      {
        path: '/analysis/help',
        name: 'Analysis',
        component: () => import('./views/analysisPipelines/help.vue')
      },
    ]
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    children: [
      {
        path: '/home',
        name: '首页',
        component: Home
      },
      // 404页面
      {
        path: "/404",
        name: "404页面",
        component: () => import('./views/defaultPages/404'),
      },
      {
        path: "/noline",
        name: "noline页面",
        component: () => import('./views/defaultPages/noLine'),
      }, {
        path: '/profile',
        name: '个人中心',
        icon: '/',
        component: () => import('./views/personal/Profile.vue')
      }, {
        path: '/note',
        name: '消息中心',
        icon: '/',
        component: () => import('./views/note/index.vue') //路由懒加载
      }, {
        path: "/sample",
        name: "样本管理",
        icon: "/icon/yangbenguanli.png",
        component: r => require.ensure([], () => r(require('./views/sample/index.vue')), 'sample') // router路由懒加载（按需加载：也叫延迟加载或者懒加载,即在需要的时候进行加载，随用随载）
        // component: () => import('./views/sample/index.vue')
      }, {
        path: "/sample/detail",
        name: "样本详情",
        icon: "/icon/yangbenguanli.png",
        component: () => import('./views/sample/detail.vue')
      },
      // statistics
      {
        path: "/statistics",
        name: "统计分析",
        icon: "/icon/tongjifenxi.png",
        component: () => import('./views/statistics/index.vue')
      },
      {
        path: "/diagnosis",
        name: "就诊流程",
        icon: "/icon/liucheng-3.png",
        component: () => import('./views/diagnosis/index.vue')
      }, {
        path: "/diagnosis/details",
        name: "就诊详情",
        icon: "/icon/liucheng-3.png",
        component: () => import('./views/diagnosis/details.vue')
      },
      {
        path: "/sufferer/moreEdit",
        name: "编辑管理页面",
        icon: "/icon/liucheng-3.png",
        component: () => import('./views/sufferer/moreEdit.vue')
      },
      {
        path: "/sufferer/edit",
        name: "编辑管理页面",
        icon: "/icon/liucheng-3.png",
        component: () => import('./views/sufferer/edit.vue')
      },
      {
        path: "/sufferer/nogroup",
        name: "就诊流程",
        icon: "/icon/liucheng-3.png",
        component: () => import('./views/sufferer/noGroup.vue')
      },
      {
        path: "/sufferer",
        name: "患者管理",
        icon: "/icon/huanzhe2.png",
        component: () => import('./views/sufferer/index.vue')
      },
      {
        path: "/sufferer/detail",
        name: "患者详情",
        icon: "/icon/liucheng-3.png",
        component: () => import('./views/sufferer/detail.vue')
      },
      {
        path: "/job",
        name: "作业管理",
        icon: "/icon/zuoye.png",
        component: () => import('./views/job/index.vue')
      },
      {
        path: "/job/add",
        name: "提交作业",
        icon: "/icon/zuoye.png",
        component: () => import('./views/job/add.vue')
      },
      {
        path: "/job/details",
        name: "作业详情",
        icon: "/icon/zuoye.png",
        component: () => import('./views/job/details.vue')
      },
      {
        path: "/report",
        name: "报告管理",
        icon: "/icon/xingzhuang.png",
        component: () => import('./views/report/index.vue')
      }, {
        path: "report/details",
        name: "报告详情",
        component: () => import('./views/report/details.vue')
      },
      {
        path: "turn",
        name: "总控设置",
        icon: "/icon/xingzhuang.png",
        component: TurnInex,
        children: [{
          path: "user",
          name: "用户管理",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/userIndex.vue'),
        }, {
          path: "role",
          name: "角色管理",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/roleIndex.vue'),
        }, {
          path: "dept",
          name: "组织机构",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/deptIndex.vue'),
        }, {
          path: "basedb",
          name: "跟踪状态设置",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/baseDataIndex.vue'),
        }, {
          path: "group/patients",
          name: "患者分组设置",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/groupPatientsIndex.vue'),
        }, {
          path: "auto/job",
          name: "自动作业设置",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/autojob.vue'),
        }, {
          path: "early/warning",
          name: "预警设置",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/earlyWarningIndex.vue'),
        }, {
          path: "molecular/typing",
          name: "分子分型",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/molecularTypingIndex.vue'),
        }, {
          path: "sample",
          name: "样本类型设置",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/sampleIndex.vue'),
        }, {
          path: "ckpro",
          name: "项目检查设置",
          meta: {
            isPageMenu: true,
            parentMenu: {
              path: "turn",
              name: "总控设置",
            },
          },
          component: () => import('./views/turnSystem/ckproIndex.vue'),
        },


        ]
      }, {
        path: "turn/import",
        name: "导入用户",
        component: () => import('./views/turnSystem/import.vue')
      }]
  },
  {
    path: '/hometest',
    name: 'hometest',
    component: Home
  },
  {
    path: '/login',
    name: '登录页',
    component: LoginView
  },
  // {
  //   path: '/d3_one',
  //   name: 'd3_one',
  //   component: () => import('./views/testD3/testd3_one.vue')
  // },
  // {
  //   path: '/d3_two',
  //   name: 'd3_two',
  //   component: () => import('./views/testD3/testd3_two.vue')
  // },
  // {
  //   path: '/d3_three',
  //   name: 'd3_three',
  //   component: () => import('./views/testD3/testd3_three.vue')
  // },
  // {
  //   path: '/d3_four',
  //   name: 'd3_four',
  //   component: () => import('./views/testD3/testd3_four.vue')
  // },
  // {
  //   path: '/echars1',
  //   name: 'echars1',
  //   component: () => import('./views/testD3/testEchars1.vue')
  // },
  // {
  //   path: '/echars2',
  //   name: 'echars2',
  //   component: () => import('./views/testD3/testEchars2.vue')
  // },
  {
    path: '/loginpass',
    name: '忘记密码',
    component: PassWord
  },
  {
    path: '/sample/retrieval',
    name: '入库',
    component: () => import('./views/sample/retrieval.vue')
  },
  {
    path: '/sufferer/merge',
    name: '患者合并',
    component: () => import('./views/sufferer/merge.vue')
  },
  { path: '*', component: () => import('./views/404.vue') }
];

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

let router = new Router({
  mode: 'hash', // history
  base: process.env.BASE_URL,
  routes: routes,
  //跳转页面后置顶——在此
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// '/turn/group/patients', '/turn/molecular/typing',
const whiteList = ['/login', '/loginpass', '/index', '/analysis', '/analysis/details', '/analysis/help'];
const commList = ['/404', '/home', '/login', '/loginpass', '/profile', '/note', '/index', '/analysis', '/analysis/details', '/analysis/help'];

function authMenu(to) {
  const allMenus = db.get('userMenusAllMenus') || [];
  if (allMenus.length) {
    return allMenus.find(item => item.name == to.name);
  }
}

// 简单配置
NProgress.inc(0.2);
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false });

router.beforeEach((to, from, next) => {
  NProgress.start();
  let token = Cookies.get('token') // || db.get('token')
  let user = db.get('userInfo') || null;
  if (token && token.length && user) {  // 判断该路由是否需要登录权限
    if (commList.indexOf(to.path) !== -1) {
      next();
    } else {
      // next();
      let currentMenu = null;
      let currentChild = null;
      if (to.meta.isPageMenu) {
        currentChild = authMenu(to.meta.parentMenu);
        currentMenu = authMenu(to);
      } else {
        currentMenu = authMenu(to);
      }
      if (currentMenu) {
        db.saveLoaclStorage('currentMenu', currentMenu || {});
        db.saveLoaclStorage('currentChild', currentChild || {});
        next();
      } else {
        message.error('您没有页面的权限，如需要权限，请联系管理员添加');
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;